import { render, staticRenderFns } from "./MotorUserDob.vue?vue&type=template&id=8a193e20&scoped=true"
import script from "./MotorUserDob.vue?vue&type=script&lang=js"
export * from "./MotorUserDob.vue?vue&type=script&lang=js"
import style0 from "./MotorUserDob.vue?vue&type=style&index=0&id=8a193e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a193e20",
  null
  
)

export default component.exports